import axios from 'axios';
import { Notistack } from 'app/shared/components/Notistack/Notistack';
import { SERVICES } from 'app/shared/constants/apiConfig';
import { IStateRegulationModel } from './interfaces';

export const requestUpdateStateRegulation = async(
  values: Omit<IStateRegulationModel, 'updatedBy' | 'updatedDate'>,
) => {
  try {
    await axios.patch(`${SERVICES.CONFIGURATION}/state-regulation-configurations/${values.id}`, values);
    Notistack.successMessage('State Regulation Configurations - Updated Successfully');
  } catch {
    Notistack.generalError();
  }
};
